export default __webpack_public_path__ + "static/media/overview-map.cb6e8f6e.png";